import React from 'react';
import { object } from 'prop-types';

import Section from '~/views/common/Section';
import DataTable from '~/views/common/DataTable';
import BoolIcon from '../../../common/BoolIcon';

import { fmt } from '~/utils';


const FeatureFlags = ({
    feature_flags,
}) => {
    const feature_list = Object.entries(feature_flags);

    return (
        <Section name="Feature Flags">
            { feature_list.length ? (
                <DataTable.Body>
                    { feature_list.map(([name, value]) => (
                        <DataTable.Row key={name} header={fmt(name)}>
                            <BoolIcon value={value} />
                        </DataTable.Row>
                    )) }
                </DataTable.Body>
            ) : (
                <div>Not configured</div>
            ) }
        </Section>
    );
};


FeatureFlags.propTypes = {
    feature_flags: object,
};

FeatureFlags.defaultProps = {
    feature_flags: {},
};

export default FeatureFlags;
